<template>
    <span v-if="current" class="vuetify-wrapper mep24-integration-status" :data-status="current.status">
        <v-tooltip top max-width="360">
            <template v-slot:activator="{ on, attrs }">
                <v-chip x-small :color="color" v-bind="attrs" v-on="on">MEP24: {{ label }}</v-chip>
            </template>
            <span>
                {{ label }}<br>
                <template v-if="current.action">Aktion: {{ current.action }}<br></template>
                Versuche: {{ current.attempts || 0 }}<br>
                <template v-if="current.last_attempt_at">Letzter Versuch: {{ current.last_attempt_at }}<br></template>
                <template v-if="current.succeeded_at">Synchronisiert: {{ current.succeeded_at }}<br></template>
                <template v-if="current.remote_id">MEP24-ID: {{ current.remote_id }}<br></template>
                {{ current.last_error && current.last_error.message }}
            </span>
        </v-tooltip>
        <v-btn v-if="current.can_retry" x-small text :loading="loading" :disabled="loading"
               class="mep24-retry" @click="retry">Erneut versuchen</v-btn>
        <span v-if="error" class="red--text mep24-error" role="alert">{{ error }}</span>
    </span>
</template>

<script>
import axios from 'axios';

const LABELS = {
    unknown: 'Verlauf unbekannt', pending: 'Wartend', processing: 'Wird gesendet',
    retrying: 'Wiederholung geplant', succeeded: 'Synchronisiert',
    failed: 'Fehlgeschlagen', configuration_error: 'Konfiguration prüfen',
};

export default {
    props: { appointmentid: String, status: Object },
    data() { return { current: this.status, loading: false, error: '', timer: null, disposed: false, pollFailures: 0 }; },
    computed: {
        label() { return LABELS[this.current?.status] || LABELS.unknown; },
        color() {
            if (this.current?.status === 'succeeded') return 'green lighten-4';
            if (['failed', 'configuration_error'].includes(this.current?.status)) return 'red lighten-4';
            return this.active ? 'amber lighten-4' : 'grey lighten-3';
        },
        active() { return ['pending', 'processing', 'retrying'].includes(this.current?.status); },
    },
    watch: {
        status(value) { this.current = value; this.schedule(); },
    },
    mounted() { this.schedule(); },
    beforeDestroy() { this.disposed = true; clearTimeout(this.timer); },
    methods: {
        schedule() {
            clearTimeout(this.timer);
            const delay = Math.min(4000 * (2 ** this.pollFailures), 30000);
            if (!this.disposed && this.active) this.timer = setTimeout(this.refresh, delay);
        },
        async refresh() {
            if (this.disposed) return;
            try {
                const response = await axios.get(`/api/appointments/${this.appointmentid}/integrations/mep24`);
                if (this.disposed) return;
                this.pollFailures = 0;
                this.error = '';
                this.current = response.data;
                this.$emit('update', { _id: this.appointmentid, mep24_integration: this.current });
            } catch (error) {
                if (this.disposed) return;
                this.error = 'MEP24-Status konnte nicht geladen werden.';
                const status = error?.response?.status;
                if (status && status < 500 && status !== 429) return;
                this.pollFailures = Math.min(this.pollFailures + 1, 3);
            }
            this.schedule();
        },
        async retry() {
            if (this.disposed) return;
            this.loading = true;
            this.error = '';
            try {
                const response = await axios.post(`/api/appointments/${this.appointmentid}/integrations/mep24/retry`, {
                    operation_id: this.current.operation_id,
                });
                if (this.disposed) return;
                this.current = response.data;
                this.$emit('update', { _id: this.appointmentid, mep24_integration: this.current });
                this.schedule();
            } catch (error) {
                if (this.disposed) return;
                this.error = error?.response?.status === 403 ? 'Keine Entwicklerberechtigung.'
                    : error?.response?.status === 409 ? 'Vorgang bereits aktiv oder Abgleich erforderlich.'
                    : 'MEP24-Wiederholung konnte nicht gestartet werden.';
                await this.refresh();
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
